/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

 import { defineComponent } from "vue";

 export default defineComponent({
   emits: ["click"],
 });
 